import { API_BASE_URL } from '@/api/config'
import { useUser } from '@/api/hooks/users/useUser'
import { useSecurityContext } from '@/contexts/SecurityContext'
import type { UserMenuItem } from '@gravitate-js/excalibrr'
import {
  DefaultUserPanel,
  MaterialIcon,
  Vertical,
  useThemeContext,
} from '@gravitate-js/excalibrr'
import { NavTenantSelector } from './NavTenantSelector'

export const BottomNavSlot = () => {
  const { data: user } = useUser()
  const { handleLogout, hasGravitateAccess } = useSecurityContext()
  const { availableThemes, currentTheme, setTheme } = useThemeContext()

  const openApiDocs = () => {
    const token = localStorage.getItem('accessToken')
    if (!token) return
    const base = API_BASE_URL.endsWith('/')
      ? API_BASE_URL.slice(0, -1)
      : API_BASE_URL
    window.open(
      `${base}/docs#access_token=${encodeURIComponent(token)}`,
      '_blank',
      'noopener,noreferrer',
    )
  }

  const menuItems: UserMenuItem[] = [
    {
      key: 'theme',
      type: 'select',
      label: 'Theme',
      description: 'Customize the application appearance',
      icon: <MaterialIcon icon='palette' />,
      value: currentTheme,
      options: availableThemes.map((theme) => ({
        value: theme.key,
        label: theme.display,
      })),
      onChange: setTheme,
    },
    { key: 'divider1', type: 'divider' },
    ...(hasGravitateAccess()
      ? [
          {
            key: 'api-docs',
            type: 'action',
            icon: <MaterialIcon icon='api' />,
            label: 'Go to API',
            onClick: openApiDocs,
          } as UserMenuItem,
        ]
      : []),
    {
      key: 'logout',
      type: 'action',
      icon: <MaterialIcon icon='logout' />,
      label: 'Logout',
      onClick: handleLogout,
    },
  ]

  return (
    <Vertical gap={0} style={{ width: '100%' }}>
      {/* Tenant Selector */}
      <NavTenantSelector isExpanded={true} />

      {/* User Info */}
      <DefaultUserPanel
        user={{
          name: user?.name,
        }}
        menuItems={menuItems}
      />
    </Vertical>
  )
}
